import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PlusCircle, Video, Users, FileText } from "lucide-react";

interface TypeSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectMentoria: () => void;
  onSelectConteudo: () => void;
}

export const TypeSelectionModal: React.FC<TypeSelectionModalProps> = ({
  isOpen,
  onClose,
  onSelectMentoria,
  onSelectConteudo
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-[#1E293B] text-white border-[#2A3749] max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center flex items-center justify-center gap-2">
            <PlusCircle className="h-6 w-6 text-[#00B6F0]" />
            Novo Serviço
          </DialogTitle>
          <DialogDescription className="text-gray-400 text-center">
            Que tipo de serviço você gostaria de criar?
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          {/* Mentoria */}
          <Card 
            className="bg-[#242C37] border-[#2A3749] hover:border-[#00B6F0] transition-colors cursor-pointer group"
            onClick={onSelectMentoria}
          >
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 p-4 bg-[#1E293B] rounded-full w-16 h-16 flex items-center justify-center group-hover:bg-[#00B6F0]/10 transition-colors">
                <Users className="h-8 w-8 text-[#00B6F0]" />
              </div>
              <CardTitle className="text-xl text-white">Mentoria</CardTitle>
              <CardDescription className="text-gray-400">
                Sessão ao vivo com agendamento
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-2 text-sm text-gray-300">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#00B6F0] rounded-full"></div>
                  <span>Sessão individual ou em grupo</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#00B6F0] rounded-full"></div>
                  <span>Horário agendado pelo jogador</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#00B6F0] rounded-full"></div>
                  <span>Duração definida</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#00B6F0] rounded-full"></div>
                  <span>Preço por sessão</span>
                </div>
              </div>
              
              <Button 
                className="w-full mt-4 bg-[#00B6F0] text-black hover:bg-[#00A3D9] font-medium"
                onClick={onSelectMentoria}
              >
                Criar Mentoria
              </Button>
            </CardContent>
          </Card>

          {/* Conteúdo Digital */}
          <Card 
            className="bg-[#242C37] border-[#2A3749] hover:border-[#00B6F0] transition-colors cursor-pointer group"
            onClick={onSelectConteudo}
          >
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 p-4 bg-[#1E293B] rounded-full w-16 h-16 flex items-center justify-center group-hover:bg-[#00B6F0]/10 transition-colors">
                <FileText className="h-8 w-8 text-[#00B6F0]" />
              </div>
              <CardTitle className="text-xl text-white">Conteúdo Digital</CardTitle>
              <CardDescription className="text-gray-400">
                Material digital para venda
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-2 text-sm text-gray-300">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#00B6F0] rounded-full"></div>
                  <span>PDF, vídeo, áudio ou imagem</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#00B6F0] rounded-full"></div>
                  <span>Acesso imediato após compra</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#00B6F0] rounded-full"></div>
                  <span>Link externo (Drive, YouTube, etc.)</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#00B6F0] rounded-full"></div>
                  <span>Preço único</span>
                </div>
              </div>
              
              <Button 
                className="w-full mt-4 bg-[#00B6F0] text-black hover:bg-[#00A3D9] font-medium"
                onClick={onSelectConteudo}
              >
                Criar Conteúdo
              </Button>
            </CardContent>
          </Card>
        </div>
        
        <div className="mt-6 p-4 bg-[#242C37] rounded-lg border border-[#2A3749]">
          <p className="text-sm text-gray-400 text-center">
            💡 <strong className="text-white">Dica:</strong> Ambos os serviços usam o mesmo sistema de pagamento Stripe e aparecerão no seu perfil público
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}; 